import React from 'react'
import { IconOptionGrid, IconOption } from '../ui'
import { AlertCircle } from 'lucide-react'

interface IconOptionFieldProps {
 label: string
 value: string
 options: IconOption[]
 onChange: (value: string) => void
 name: string
 columns?: 2 | 3 | 4 | 5 | 6
 required?: boolean
 error?: string
 hint?: string
}

export const IconOptionField: React.FC<IconOptionFieldProps> = ({
 label,
 value,
 options,
 onChange,
 name,
 columns = 5,
 required = false,
 error,
 hint
}) => {
 return (
 <div>
 <label className="block text-sm font-medium text-foreground mb-3">
 {label}
 {required && <span className="text-red-500 ml-1">*</span>}
 </label>
 
 <IconOptionGrid
 value={value}
 options={options}
 onChange={onChange}
 name={name}
 columns={columns}
 required={required}
 error={error}
 />
 
 {hint && !error && (
 <p className="mt-2 text-xs text-muted-foreground">{hint}</p>
 )}
 
 {error && !hint && (
 <div className="mt-2 flex items-center text-xs text-red-600 dark:text-red-400">
 <AlertCircle className="h-3 w-3 mr-1" />
 {error}
 </div>
 )}
 </div>
 )
}

